import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesPlugin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 6.1h-1.52v1.52h-1.53v1.53h1.53v1.52h1.52V9.15H32V7.62h-1.52zm0 12.19h-1.52v-1.52h-3.05v-6.1H15.24v6.1H4.57v1.52H3.05v1.52H1.53v1.53H0v1.52h4.57V32h22.86v-9.14H32v-3.05h-1.52Zm-13.72-6.1h7.62v4.58h-7.62Zm1.53 18.29H6.1v-7.62h10.66v-1.52h1.53Zm7.62 0h-6.1V18.29h6.1Zm-6.1-27.43h1.53v1.53h-1.53Z\"/><path fill=\"currentColor\" d=\"M16.76 0v7.62h7.62V6.1h-1.52V4.58h-1.52V6.1h-3.05V3.05h1.52V1.53h-1.52V0zm-4.57 7.62h1.53v4.57h-1.53Zm-1.52 4.57h1.52v1.53h-1.52Zm0-6.09h1.52v1.52h-1.52ZM6.1 13.72h4.57v1.52H6.1Zm0-9.14h4.57V6.1H6.1Zm-1.53 7.61H6.1v1.53H4.57Zm0-6.09H6.1v1.52H4.57ZM3.05 7.62h1.52v4.57H3.05ZM1.53 1.53h1.52v1.52H1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesPlugin
